import React, { useState, useEffect } from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";
import { Row, Col } from "reactstrap";
import "../../../../styles/estilos.css";
import { useHistory } from "react-router-dom";
import LoadingScreen from "react-loading-screen";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import "react-datepicker/dist/react-datepicker.css";

import { urlGuardarRenovaciones } from "../../api/urls";
import { apiGet, apiPost2 } from "../../../../api";
import { tramaSuscripcionTarjetaP2P } from "../../../../constants/tramas/tramasPago";
import NumberFormat from 'react-number-format';
import ValoresRenovacion from "../../components/ValoresRenovacion";
import moment from "moment";
import { RAMO_ENUM } from "../../constants/ramosEnums";
import RenovacionVehiculos from "../../components/RenovacionVehiculos";
import RenovacionPymes from "../../components/RenovacionPymes";
import { httpClient } from "../../../../api/httpClient";
import publicIp from "public-ip";

const Renovacion = ({ dataRenovacion }) => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [errorSumaAsegurada, setErrorSumaAsegurada] = useState('');
  const [tieneError, setTieneError] = useState(false);
  const [mensajeError, setMensajeError] = useState('');
  const [email, setEmail] = useState('');
  const [valorAsegurado, setValorAsegurado] = useState(0);

  const ramoSeguro = (dataRenovacion && dataRenovacion.ramo) ||
    (dataRenovacion && dataRenovacion.reDatosProducto && dataRenovacion.reDatosProducto.reRamoProducto === 'PYMES' ? 'PYMES' : (dataRenovacion && dataRenovacion.reDatosProducto && dataRenovacion.reDatosProducto.reRamo)) || "";
  const esVehiculos = ramoSeguro === RAMO_ENUM.VEHICULOS;

  const productoSeguro = (dataRenovacion && dataRenovacion.polDescripcionSeguroVer) ||
    (dataRenovacion && dataRenovacion.reDatosProducto && dataRenovacion.reDatosProducto.reProducto) || "";

  const vehiculos = (dataRenovacion && dataRenovacion.reDatosProducto && dataRenovacion.reDatosProducto.reDatosVehiculo) || [];
  const placaVehiculo = (dataRenovacion && dataRenovacion.rePlacaVehiculoVer) ||
    (vehiculos.length > 0 && vehiculos[0] ? vehiculos[0].rePlaca : "");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const onClickAtras = () => {
    history.push({
      pathname: "/listado-renovaciones"
    });
  };

  const onClickContinuar = async (e) => {
    if (valorAsegurado > 0) {
      setIsLoading(true);
      try {
        const url = `${urlGuardarRenovaciones}${dataRenovacion.numeroPolizaEmision}`;
        const data = await httpClient.get(url);

        if (data.transaccion) {
          history.push({
            pathname: "/resumen-cotizacion",
            search: `?id=${data.data.idCarrito}&paso=resumen&codigoProductoEspecial=comparador&esRenovacion=true`
          });
        } else {
          if (data.errorDescripcion) {
            setTieneError(true);
            setMensajeError(data.errorDescripcion);
          }
        }
      } catch (error) {
        console.error("Error al continuar:", error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const irAFormularioVinculacion = (idCarrito) => {
    history.push({
      pathname: "/forma-pago",
      search: `?id=${idCarrito}`,
    });
  };

  // suscribir tarjeta p2p
  const SuscripcionTarjetaP2P = async (pagador, idPoliza, suscripcionP2P, placetoPay) => {
    const nombre = pagador.cliNombre1;
    const apellido = pagador.cliApellido1;
    const email = pagador.cliEmail;
    const identificacion = pagador.cliIdentificacion;
    const tipoDocumento = pagador.cliCodigoTipoDocumento === 'CÉDULA' ? 'CI' : (pagador.cliCodigoTipoDocumento === 'RUC' ? 'RUC' : 'PAS');
    const celular = pagador.cliCelular;
    let cliIp = '';
    
    try {
      cliIp = await publicIp.v4();
      const body = tramaSuscripcionTarjetaP2P({
        idPoliza, nombre, apellido, email, identificacion, tipoDocumento, celular, cliIp
      });

      await suscripcionP2P(body);
      if (placetoPay && placetoPay.suscripcionTarjetaP2PResponse && placetoPay.suscripcionTarjetaP2PResponse.traUrl) {
        window.location.href = placetoPay.suscripcionTarjetaP2PResponse.traUrl;
      }
    } catch (error) {
      console.error("Error en SuscripcionTarjetaP2P:", error);
    }
  };

  const obtenerNombreODenominacion = (datos) => {
    if (!datos) return "";

    if (datos.reIdentificacion && datos.reIdentificacion.length === 13 && datos.reIdentificacion.endsWith("001")) {
      return datos.reRazonSocial || (datos.reNombre1 ? datos.reNombre1 + " " : "") +
        (datos.reNombre2 ? datos.reNombre2 + " " : "") +
        (datos.reApellido1 ? datos.reApellido1 + " " : "") +
        (datos.reApellido2 ? datos.reApellido2 : "");
    }

    return (
      (datos.reNombre1 ? datos.reNombre1 + " " : "") +
      (datos.reNombre2 ? datos.reNombre2 + " " : "") +
      (datos.reApellido1 ? datos.reApellido1 + " " : "") +
      (datos.reApellido2 ? datos.reApellido2 : "")
    ).trim();
  };

  const obtenerEdad = (asegurado) => {
    if (!asegurado || !asegurado.reFechaNacimiento) {
      return "S/N";
    }

    const fechaNacimiento = moment(asegurado.reFechaNacimiento, "DD/MM/YYYY");

    if (!fechaNacimiento.isValid()) {
      return "S/N";
    }

    return moment().diff(fechaNacimiento, "years");
  };

  const textosCargando = () => {
    if (loadingMessage) {
      return loadingMessage;
    }
    if (isLoading) {
      return "Guardando información...";
    }
    return "Cargando...";
  };

  return (
    <LoadingScreen
      loading={isLoading}
      bgColor="#f1f1f1"
      spinnerColor="#001871"
      textColor="#676767"
      logoSrc={logo}
      text={textosCargando()}
    >
      {dataRenovacion ? (
        <Row>
          {esVehiculos ? (
            <RenovacionVehiculos
              dataRenovacion={dataRenovacion}
              obtenerNombreODenominacion={obtenerNombreODenominacion}
              obtenerEdad={obtenerEdad}
              onClickAtras={onClickAtras}
            />
          ) : (
            <RenovacionPymes
              dataRenovacion={dataRenovacion}
              obtenerNombreODenominacion={obtenerNombreODenominacion}
              onClickAtras={onClickAtras}
            />
          )}

          <Col lg={4} md={12} sm={12} xs={12} className="detalle-impuestos-box">
            <ValoresRenovacion
              key={1}
              setLoading={(value, message = '') => {
                setIsLoading(value);
                setLoadingMessage(message);
              }}
              producto={productoSeguro}
              dataRenovacion={dataRenovacion}
              tieneError={tieneError}
              mensajeError={mensajeError}
              paso={"datos-cotizacion"}
              placa={placaVehiculo}
              urlPdf={null}
              completo={false}
              planes={[]}
              totales={null}
              email={email}
              metodoEnviar={() => { }}
              setEmail={setEmail}
              planSeleccionado={null}
              codigoProductoEspecial={false}
              codeProductoEspecial={null}
              disabled={errorSumaAsegurada !== ''}
            />
          </Col>
        </Row>
      ) : null}
    </LoadingScreen>
  );
};

export default Renovacion;
